import {
    loanTermDefaultAEM,
    loanTermsDefault,
    LoanTermState,
} from './loanTermTypes';
import { ApiStatus } from '../../types';
export const initialStateLoanTerm: LoanTermState = {
    content: loanTermDefaultAEM,
    loanOptions: loanTermsDefault,
    getLoanTermApiStatus: ApiStatus.Idle,
    updateLoanTermApiStatus: ApiStatus.Idle,
    apiEndpoints: {
        getLoanTermApiUrl: '/getLoanTerms',
        updateLoanTermApiUrl: '/saveLoanTerms',
    },
    loanOptionsRequest: {
        applicationNumber: '123456',
        purchaseAmount: 10000,
        loanTermYear: 1,
        repaymentAmount: 100,
    },
};
